/**
 * UranIA PA — Route shell `/workspace/mod5/$docId` (US-023 AC#1+AC#6).
 *
 * Definizione route TanStack Router **senza component**: il componente
 * arriva via `.lazy()` chunk separato (`mod5.$docId.lazy.tsx`) cosi'
 * che il bundle iniziale dell'SPA non includa il workspace Mod5 finche'
 * l'utente non naviga a `/workspace/mod5/<docId>` (AC US-023 #6 letterale
 * "Bundle route lazy < 100 KB gz").
 *
 * Pattern manual code splitting (non file-based) per TanStack Router v1:
 *   shell  (questo file)    -> `createRoute({...}).lazy(...)`
 *   lazy   (file affiancato) -> `createLazyRoute(path)({ component })`
 *
 * Niente loader o `beforeLoad`: la session guard e' delegata al
 * componente (pattern uniforme con `/dashboard`, `/admin/*`,
 * `/chat-prova` US-011/028/029/030 che non usano `beforeLoad` ma
 * `useAuthStore` lato component).
 */

import { createRoute } from '@tanstack/react-router';

import { Route as RootRoute } from '../__root.tsx';

export const WORKSPACE_MOD5_PATH = '/workspace/mod5/$docId';

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: WORKSPACE_MOD5_PATH,
}).lazy(() => import('./mod5.$docId.lazy.tsx').then((module) => module.Route));
